import { useState } from "react";
import TrainerContext from "./TrainerContext";

export const trainerContextStore: {
  setTrainerState: undefined | ((data: any) => void);
  getTrainerState: (() => { [key: string]: any }) | undefined;
} = {
  setTrainerState: undefined,
  getTrainerState: undefined,
};

const TrainerContextProvider = ({ children }: any) => {
  const [trainerData, setTrainerData] = useState({
    trainerName: "",
    trainerId: "",
    trainerCategory: "",
    trainerEmail: "",
    token: "",
    refreshToken: "",
    trainerIsAdmin: true,
    permissions: [],
    trainerImage: "",
    trainerDescription: "",
  });

  const setTrainerState = (data: any) => {
    setTrainerData({
      ...trainerData,
      ...data,
    });
    localStorage.setItem(
      "trainerData",
      JSON.stringify({
        ...trainerData,
        ...data,
      })
    );
  };

  const getTrainerState = () => {
    if (trainerData.token === "") {
      const data = localStorage.getItem("trainerData");
      if (!data) {
        return trainerData;
      }
      const parsedData = JSON.parse(data);
      return parsedData;
    }
    return trainerData;
  };

  trainerContextStore.setTrainerState = setTrainerState;
  trainerContextStore.getTrainerState = getTrainerState;

  return (
    <TrainerContext.Provider
      value={{
        setTrainerState,
        getTrainerState,
      }}
    >
      {children}
    </TrainerContext.Provider>
  );
};

export default TrainerContextProvider;
